export default __webpack_public_path__ + "static/media/davisville.3e664c1f.jpg";